import { setCypressID } from 'src/utils/setCypressID';

/**
 * Used for constructing test ID maps for DOM testing
 *
 * @deprecated This class was an experiment for a more powerful testing id system, but it's proven more boilerplate
 * than feature at this point. Revert back to using setCypressID and CYPRESS_INTEGRATION_TEST_IDS
 */
export class TestID {
    private _testID: string;
    private _additionalDataAttributes?: Record<string, string>;
    constructor(name: string, additionalDataAttributes?: Record<string, string>) {
        this._testID = name;
        this._additionalDataAttributes = additionalDataAttributes;
    }

    get id(): string {
        return this._testID;
    }

    public getCypressTestIDAttribute() {
        if (this._additionalDataAttributes) {
            return {
                ...this._additionalDataAttributes,
                ...setCypressID(this.id),
            };
        }
        return setCypressID(this.id);
    }

    public getNestedTestID(name: string, additionalDataAttributes?: Record<string, string>) {
        return new TestID(`${this.id}|${name}`, additionalDataAttributes);
    }
}
